import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { getError } from '@principle-theorem/shared';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root',
})
export class GCloudErrorHandlerService
  extends ErrorHandler
  implements ErrorHandler
{
  constructor(private injector: Injector) {
    super();
  }

  override handleError(error: unknown): void {
    try {
      this._report(error);
    } catch (reportingError) {
      // eslint-disable-next-line no-console
      console.error('Failed to report error to GCloud', reportingError);
    } finally {
      super.handleError(error);
    }
  }

  private _report(error: unknown): void {
    const message = getError(error);
    const logger = this.injector.get(LoggerService);
    void logger.log('ERROR', message, { message }).catch(() => undefined);
  }
}
